// Empresa do usuário: vínculo direto ou, na falta dele, a empresa da filial (do usuário ou do cliente)
export const getUserCompany = (user?: any) => {
  if (!user) return null

  const direct = user.companies?.find((company: any) => company?.image)
  if (direct) return direct

  const branches = [...(user.unitBranchs || []), ...(user.client?.unitBranchs || [])]
  const fromBranch = branches.find((unitBranch: any) => unitBranch?.company?.image)?.company
  if (fromBranch) return fromBranch

  return user.companies?.[0] || null
}
